import { Cookies, HttpStatusCode, withRetry } from "aphrodite.react/Helpers";
import { DefaultLanguageClient } from "ClientApi/ClientApi";

export class Language {
    static async get(): Promise<number> {
        const override = Cookies.get("language");
        if (override) return parseInt(override);

        const response = await withRetry(() => new DefaultLanguageClient().post({
            languages: [...navigator.languages]
        }));

        if (response.status === HttpStatusCode.Http200Ok) {
            Language.set(response.result.languageId);
            return response.result.languageId;
        }
        else {
            return 1;
        }
    }

    static set(language: number): void {
        Cookies.set("language", language.toString(), 365);
    }
}